<template>
  <b-row>
    <b-col cols="12">
      <event-finish-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EventFinishTable from './EventFinishTable.vue'

export default {
  components: {
    BRow,
    BCol,

    EventFinishTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>